module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "block_"
  }), _vm._v(" "), _c('p', {
    staticClass: "block_"
  }), _vm._v(" "), _c('p', {
    staticClass: "block_"
  }), _vm._v(" "), _c('p', {
    staticClass: "block_"
  }), _vm._v(" "), _c('h1', {
    staticClass: "block_1",
    attrs: {
      "id": "toc_id_1"
    }
  }, [_vm._v("About the Author")]), _vm._v(" "), _c('p', {
    staticClass: "block_"
  }), _vm._v(" "), _c('p', {
    staticClass: "block_"
  }), _vm._v(" "), _c('p', {
    staticClass: "block_"
  }), _vm._v(" "), _c('p', {
    staticClass: "block_2"
  }, [_vm._v("Growing up near London, Carley-Ann Osborn has always had a love of books and especially loved the ones that take you on a character’s journey through their eyes. Writing was more for her own entertainment in her youth but was left on the back burner as a young adult. It wasn’t until her mid-30s that the love for reading and writing came back into her life, and she hasn’t been able to stop since.")]), _vm._v(" "), _c('p', {
    staticClass: "block_3",
    attrs: {
      "id": "calibre_pb_0"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-f6877f70","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/index_split_000.vue
// module id = 63
// module chunks = 0